/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Formik, Form as Formiker, Field as Fieldmik, FieldArray } from 'formik'
import { Form as FormUi, Segment, Button, Table, Container } from 'semantic-ui-react'
import { MyInput, MyCheckBox } from '../apiInputComponent/myInput';
import MyVehNo from '../apiInputComponent/myVehNo';
import ReadAxios from '../axiosComponent/read';
import UpdateAxios from '../axiosComponent/update';
import AddTitleBar from '../titleBar/add_titleBar'
import * as yup from 'yup';
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder';
import MyBranchAddVehicle from '../apiInputComponent/myBranchAddVehicle';
import Axios from 'axios';
import cogoToast from 'cogo-toast';
import APP_CONSTANTS from '../../config/constants';



const EditChecklist = (props) => {

    const [items, setitems] = useState([])
    const [checklistUpdate, setchecklistUpdate] = useState([])
    const [isLoading, setisLoading] = useState(true)
    
    let chkid = props.location.state.id
    console.log("Porps", props)
    useEffect(() => { 
        ReadAxios({ url: 'fleet/checklist/getCheckList', readItems: { checkListId: chkid } }).then(result => {setchecklistUpdate(result); setisLoading(false)})
    }, [])
    


    const handleSubmit = (values) =>  {
        let checklistParticular = []
        values.checkListParticulars.map((o,i) => {
            let temp = {}
            temp.checkListParticularId = o.checkListParticularId
            temp.chkParticularId = o.chkParticularId
            temp.customerNo = o.customerNo
            temp.isChecked = o.isChecked === true ? 1 : 0
            temp.particularName = o.particularName
            checklistParticular[i] = temp
        })

        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        let data = {
            customerNo: customerNo,
            userId: userId,
            checkListId: values.checkListId,
            checkListNumber: values.chkNo,
            meterReading: values.meterReading,
            vehicleId: values.vehicleNumber,
            branchId: values.branch,
            checkListParticulars: checklistParticular,
            
        }

        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/checklist/update`, data,  {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setisLoading(false)
            cogoToast(response.data.message).then(() => {
                window.location.href = '/checklist'
            })
            
        }))
        .catch(error => {
            console.log(error)
            setisLoading(false)
        })      
    }

    
    if (isLoading) {
        return <LoadingPlaceholder />
    } else {

        let checklistArray = []
        checklistUpdate && checklistUpdate[0].checklist_particulars.map((o,i) => {
        let temp = {}
        temp.checkListParticularId = o.checkListParticularId
        temp.chkParticularId = o.checkListMasterId
        temp.customerNo = o.customerNo
        temp.isChecked = o.isChecked === 0 ? false : true
        temp.particularName = o.checkListName
        checklistUpdate[0].checklist_particulars[i] = temp
        })
        
        return (
            <>
                <AddTitleBar Title="Edit Checklist" LinkName="/checklist" />
                <Formik
                    initialValues={{
                        chkNo: checklistUpdate[0].checkListNumber.toUpperCase(),
                        vehicleNumber: checklistUpdate[0].vehicleId,
                        meterReading: checklistUpdate[0].meterReading,
                        checkListParticulars: checklistUpdate[0].checklist_particulars,
                        checkListId: checklistUpdate[0].checkListId,
                        vehicleId: checklistUpdate[0].vehicleId,
                        branch: checklistUpdate[0].branchId
                    }}
    
                    validationSchema={yup.object().shape({
                        chkNo: yup.string().min(3, 'Must be more than 3 Letters').required('Checklist No. Required'),
                        vehicleNumber: yup.string().required('Vehicle No. Required'),
                        meterReading: yup.number().moreThan(0, 'Must be more than 0').required('Meter Reading Required'),
                        branch: yup.string().required('Branch Required')
                        })
                    }
                    
                    onSubmit={handleSubmit}
                >
                    {({ touched, errors, values }) => {
                        return  <Formiker>
                                    <Container fluid className="m-2">
                                        <Segment>
                                            <div className="ui form">
                                                <FormUi.Group inline>
                                                    <FormUi.Field >
                                                        <label className="labelName w3-text-blue">Basic Details</label>
                                                    </FormUi.Field>
                                                </FormUi.Group>
                                                <FormUi.Group inline>
                                                    <FormUi.Field width={3}>
                                                        <label className="labelName">Checklist Number *</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field>
                                                        <Fieldmik component={MyInput} name="chkNo" placeholder="Checklist No." error={values.chkNo ? false : true} />
                                                        {touched.chkNo && errors.chkNo ? <div className="w3-tiny w3-text-red p-bold-600">{errors.chkNo}</div> : ''}
                                                    </FormUi.Field>
                                                    <FormUi.Field width={1} />
                                                    <FormUi.Field width={3}>
                                                        <label className="labelName">Vehicle Number *</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field >
                                                        <Fieldmik component={MyVehNo} name="vehicleNumber" placeholder="Vehicle No." value={values.vehicleNumber}  error={values.vehicleNumber ? false : true}/>
                                                        {touched.vehicleNumber && errors.vehicleNumber ? <div className="w3-tiny w3-text-red p-bold-600">{errors.vehicleNumber}</div> : ''}
                                                    </FormUi.Field>
                                                </FormUi.Group>
                                                <FormUi.Group inline>
                                                    <FormUi.Field width={3}>
                                                        <label className="labelName">Meter Reading *</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field>
                                                        <Fieldmik component={MyInput} name="meterReading" placeholder="" error={values.meterReading ? false : true} />
                                                        {touched.meterReading && errors.meterReading ? <div className="w3-tiny w3-text-red p-bold-600">{errors.meterReading}</div> : ''}
                                                    </FormUi.Field>
                                                    <FormUi.Field width={1} />
                                                    <FormUi.Field width={3}>
                                                        <label className="labelName">Branch *</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field>
                                                        <Fieldmik component={MyBranchAddVehicle} name="branch" placeholder="" error={values.branch ? false : true} value={values.branch} />
                                                        {touched.branch && errors.branch ? <div className="w3-tiny w3-text-red p-bold-600">{errors.branch}</div> : ''}
                                                    </FormUi.Field>
                                                </FormUi.Group>
                                            </div>
                                        </Segment>
                                        {console.log("Values", values)}
    
                                        <Table size="small">
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell className="labelName w3-text-blue">Checklist Details</Table.HeaderCell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.HeaderCell className="labelName p-bold-600">Sr. No.</Table.HeaderCell>
                                                    <Table.HeaderCell className="labelName p-bold-600">Particulars</Table.HeaderCell>
                                                    <Table.HeaderCell className="labelName p-bold-600">Checklist</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {console.log("checklist", checklistUpdate)}
                                                <FieldArray
                                                    name="checkListParticulars"    
                                                >
                                                    {fieldarrayprops => {
                                                        const { form } = fieldarrayprops;
                                                        const { initialValues, values } = form;

                                                        return (
                                                            <>{values.checkListParticulars.map((o, i) => (
                                                                <Table.Row>
                                                                    <Table.Cell>{o.chkParticularId}</Table.Cell>
                                                                    <Table.Cell>{o.particularName}</Table.Cell>
                                                                    <Table.Cell><Fieldmik type="checkbox" name={`checkListParticulars[${i}].isChecked`} /> </Table.Cell>
                                                                </Table.Row>
                                                            ))}</>
                                                        )
                                                    }}
                                                
                                                </FieldArray>
                                            </Table.Body>
                                        </Table>
                                        <center><Button type="submit" primary size="mini">Submit</Button></center>
                                    </Container>
                                </Formiker>
                    }}
                </Formik>
            </>
        )
    }
}

export default EditChecklist